import { ProgressBar } from '@infl-ts/ui-advocate-components';
import { AppBar, Box, Skeleton } from '@mui/material';
import { Header } from '../challenge-player/challenge-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var LoadingHeader = function LoadingHeader() {
  return /*#__PURE__*/_jsxs(AppBar, {
    sx: {
      boxShadow: 'none'
    },
    color: "transparent",
    position: "sticky",
    "data-element": "AppBar",
    "data-component": "LoadingHeader",
    "data-source-file": "skeleton.tsx",
    children: [/*#__PURE__*/_jsxs(Header, {
      sx: {
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      "data-element": "Header",
      "data-component": "LoadingHeader",
      "data-source-file": "skeleton.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          borderRadius: function borderRadius(t) {
            return t.shape.borderRadius;
          }
        },
        variant: "rectangular",
        height: 32,
        width: "45%",
        "data-element": "Skeleton",
        "data-component": "LoadingHeader",
        "data-source-file": "skeleton.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        },
        "data-element": "Box",
        "data-source-file": "skeleton.tsx",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          variant: "circular",
          height: 24,
          width: 24,
          "data-element": "Skeleton",
          "data-source-file": "skeleton.tsx"
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            borderRadius: function borderRadius(t) {
              return t.shape.borderRadius;
            },
            mr: 6,
            ml: 1
          },
          variant: "rectangular",
          height: 24,
          width: 42,
          "data-element": "Skeleton",
          "data-source-file": "skeleton.tsx"
        })]
      })]
    }), /*#__PURE__*/_jsx(ProgressBar, {
      progress: 0,
      "data-element": "ProgressBar",
      "data-source-file": "skeleton.tsx"
    })]
  });
};

var PlayerSkeleton = function PlayerSkeleton() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingHeader, {
      "data-element": "LoadingHeader",
      "data-component": "PlayerSkeleton",
      "data-source-file": "skeleton.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        py: {
          xs: 3,
          md: 5
        },
        mx: 'auto',
        px: 2.5,
        maxWidth: 860,
        display: 'flex',
        flexDirection: 'column'
      },
      "data-element": "Box",
      "data-source-file": "skeleton.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mt: 4,
          mb: 5
        },
        variant: "rectangular",
        width: "100%",
        height: 400,
        "data-element": "Skeleton",
        "data-source-file": "skeleton.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mb: 1
        },
        variant: "text",
        width: 250,
        "data-element": "Skeleton",
        "data-source-file": "skeleton.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mb: 5
        },
        variant: "text",
        width: 200,
        "data-element": "Skeleton",
        "data-source-file": "skeleton.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          borderRadius: function borderRadius(t) {
            return t.shape.borderRadius;
          }
        },
        variant: "rectangular",
        width: 128,
        height: 35,
        "data-element": "Skeleton",
        "data-source-file": "skeleton.tsx"
      })]
    })]
  });
};

export default PlayerSkeleton;